import React, { FC, useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { EvSpinner } from '@evinced-private/ui-common';

import { FullPageError } from 'src/common/components/errors/full-page-error/FullPageError';
import { handleSuccessfulAuthentication } from 'src/common/helpers/AuthenticationHelper';
import { useUniversalLogin } from 'src/common/hooks/useUniversalLogin';
import { useUserTenant } from 'src/common/providers/userTenantProvider/UserTenantProvider';
import { Logger } from 'src/common/services/Logger';
import { getRedirectToPath } from 'src/common/services/LoginRedirectionService';

import { AUTH_TOKEN_LABELS } from './AuthToken.labels';

export const AuthToken: FC = () => {
	const { getAccessToken } = useUniversalLogin();
	const history = useHistory();
	const { updateUserTenant } = useUserTenant();
	const [hasAuthenticationError, setHasAuthenticationError] = useState(false);

	const handleAuthentication = useCallback(async () => {
		try {
			setHasAuthenticationError(false);
			const accessToken = await getAccessToken();
			await handleSuccessfulAuthentication(
				{ accessToken, idToken: accessToken, appState: null },
				history
			);
			await updateUserTenant();
			const { path } = getRedirectToPath();
			history.push(path);
		} catch (e) {
			Logger.error('Failed to handle authentication', e);
			setHasAuthenticationError(true);
		}
	}, [getAccessToken, history, updateUserTenant]);

	useEffect(() => {
		handleAuthentication();
	}, [handleAuthentication]);

	if (hasAuthenticationError) {
		return <FullPageError title={AUTH_TOKEN_LABELS.authenticationErrorTitle} />;
	}

	return <EvSpinner />;
};
